/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Drop_Frame_ConvertInputs */



/**
* | output |
* | --- |
* | "Drop Frame Convert" |
*
* @param {Dialogue_List_Export_Drop_Frame_ConvertInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_drop_frame_convert = /** @type {((inputs?: Dialogue_List_Export_Drop_Frame_ConvertInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Drop_Frame_ConvertInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversion drop frame")
	if (locale === "de") return /** @type {LocalizedString} */ ("Drop Frame Convert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conversione a frame eliminato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразование кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conversión de fotogramas eliminados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧转换")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドロップフレーム変換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्रॉप फ्रेम कन्वर्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Converter quadro solto")
	return /** @type {LocalizedString} */ ("Drop Frame Convert")
});